import {db} from '../modules/db';

export class NoteItem {
    id: number;
    title: string;
    content: string;
    last_updated: string;
    meta: object;

    constructor(id: number|object|null) {

        this.id = 0;
        this.title = '';
        this.content = '';
        this.last_updated = '';
        this.meta = {};

        if (typeof id === 'object') {
            this.create((id as any).title, (id as any).content);
        } else {
            if(id !== null && id !== undefined) {
                const note = this.get(id);
                if (!note) {
                    throw new Error(`Note with id ${id} not found`);
                }
            }

        }
    }

    async get(id: number): Promise<any> {
        const note = await db.notes.get(id);
        if (!note) {
            throw new Error(`Note with id ${id} not found`);
        }

        this.id = note.id;
        this.title = note.title;
        this.content = note.content;
        this.last_updated = note.last_updated;
        this.meta = await db.metadata.where('note_id').equals(this.id).toArray().then(arr => {
            const metaObj: any = {};
            arr.forEach(item => {
                metaObj[item.metakey] = item.metavalue;
            });
            return metaObj;
        });

        return this;
    }

    toArray(): Array<any> {
        return {
            id: this.id,
            title: this.title,
            content: this.content,
            last_updated: this.last_updated
        };
    }

    async updateMeta(meta:object): Promise<void> {
        if (!this.id) {
            throw new Error('Note ID is not set. Cannot update metadata.');
        }

        db.metadata.where('note_id').equals(this.id).delete();
        const updates = Object.entries(meta).map(([key, value]) => ({
            note_id: this.id,
            metakey: key,
            metavalue: value
        }));

        await db.metadata.bulkPut(updates);
    }

    async update(title: string, content: string): Promise<void> {
        let date = (new Date()).toString();
        await db.notes.update(this.id, {
            title,
            content,
            last_updated: date
        });

        await this.get(this.id);
    }

    async create(title: string, content: string): Promise<void> {
        let date = (new Date()).toString();
        const id = await db.notes.add({
            title,
            content,
            last_updated: date
        });

        this.id = id;
        this.title = title;
        this.content = content;
        this.last_updated = date;
    }
}